import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { Spanish } from 'flatpickr/dist/l10n/es';

@Component({
  selector: 'app-historial',
  templateUrl: './historial.component.html',
  styleUrls: ['./historial.component.scss']
})
export class HistorialComponent implements OnInit {

  selectalert = false;

  cups: any[] = [];
  cup: any = [];
  historial: string;
  dateandtime: string = new Date().toISOString().slice(0, 10);

  dateTime: FlatpickrOptions = {
    enableTime: true,
    dateFormat: 'Y-m-d H:i',
    locale: Spanish,
    time_24hr: true,
    onClose: (selectedDates, dateStr, instance) => this.dateandtime = dateStr
  };

  constructor(public rest: RestService) { }

  ngOnInit() {
    this.getPoints();
  }

  getPoints() {
    this.rest.getPuntos('2018').subscribe((data) => {
      this.cups = data['data'];
    });
  }

  sendHistorial() {
    this.selectalert = true;
    setTimeout(() => {
      this.selectalert = false;
    }, 1800);
    this.rest.postHistorial(this.historial, this.cup.id, this.dateandtime).subscribe((data) => {
    });
  }

}